import Head from "next/head";
import { useRouter } from "next/router";

import LearnerLogin from "../../src/accounts/components/login/LearnerLogin";
import LoginBase from "../../src/accounts/components/login/LoginBase";
import { SITE_NAME } from "../../src/common/config/seo";
import { SERVER } from "../../src/common/config/utils";

export default function () {
  const router = useRouter();
  const invitationId = new URLSearchParams(
    (router.query?.next as string)?.split("?")[1]
  ).get("invitationId");

  return (
    <>
      <Head>
        <title>Login | {SITE_NAME}</title>
        <meta
          name="description"
          content="Login to learn Data Science for free through courses, practice on real-world datasets and discuss with leading domain experts and data science enthusiasts."
        />
        <link rel="canonical" href={`${SERVER}/accounts/login`} />
        <meta property="og:url" content={`${SERVER}/accounts/login`} />
        <meta property="og:title" content={`Login | ${SITE_NAME}`} />
        <meta
          property="og:description"
          content="Login to learn Data Science for free through courses, practice on real-world datasets and discuss with leading domain experts and data science enthusiasts."
        />
        <meta
          property="og:image"
          content={`${SERVER}/accounts/login-og-image.png`}
        />
        {/* twitter tags */}
        <meta property="twitter:url" content={`${SERVER}/accounts/login`} />
        <meta name="twitter:title" content={`Login | ${SITE_NAME}`} />
        <meta
          name="twitter:description"
          content="Login to learn Data Science for free through courses, practice on real-world datasets and discuss with leading domain experts and data science enthusiasts."
        />
        <meta
          name="twitter:image"
          content={`${SERVER}/accounts/login-og-image.png`}
        />
      </Head>
      {invitationId ? (
        <LearnerLogin invitationId={invitationId} />
      ) : (
        <LoginBase />
      )}
    </>
  );
}
